import { FilterField, FilterFieldType, FilterFieldConfig } from '../filter';

export interface MultiSelectFilterFieldConfig extends FilterFieldConfig {
  optionDisplayProperty?: string;
  optionIdProperty?: string;
  options?: any[];
  selected?: any[];
  placeholderText?: string;
  limitResults?: boolean;
}

export class MultiSelectFilterField extends FilterField<any[]> {
  readonly type: FilterFieldType = 'multi-select';
  optionDisplayProperty: string | null;
  optionIdProperty: string | null;
  selected: any[];
  displayProperty: string;
  placeholderText: string | null;
  limitResults: boolean;

  constructor(config: MultiSelectFilterFieldConfig) {
    super(config);
    this.optionDisplayProperty = config.optionDisplayProperty || null;
    this.optionIdProperty = config.optionIdProperty || null;
    this.selected = config.selected || [];
    this.placeholderText = config.placeholderText || null;
    this.limitResults = config.limitResults || false;
  }

  removeValue(value: any): void {
    if (Array.isArray(this.value)) {
      const index = this.value.indexOf(value);
      this.value.splice(index, 1);
    }
    if (this.valueChanged) {
      this.valueChanged(this);
    }
  }

  public clearValue(): void {
    this.value = [];
    if (this.valueChanged) {
      this.valueChanged(this);
    }
  }

  appliedFieldText(value?: any): string {
    let buttonText = '';
    if (this.optionDisplayProperty) {
      buttonText += `${this.name}: ${value[this.optionDisplayProperty]}`;
    } else {
      buttonText += `${this.name}: ${value}`;
    }
    return buttonText;
  }

  serializeValue(): string {
    let queryParam = '';
    this.value!.forEach((item) => {
      if (this.optionIdProperty) {
        queryParam += `,${item[this.optionIdProperty]}`;
      } else if (this.optionDisplayProperty) {
        queryParam += `,${item[this.optionDisplayProperty]}`;
      } else {
        queryParam += ',' + item;
      }
    });
    queryParam = queryParam.substring(1);
    return queryParam;
  }

  deserializeValue(urlParam: string): any[] {
    const paramsList = urlParam.split(',');
    if (this.optionIdProperty) {
      return this.options.filter((option) => {
        return paramsList.some((param) => {
          return param === option[this.optionIdProperty!];
        });
      });
    } else if (this.optionDisplayProperty) {
      return this.options.filter((option) => {
        return paramsList.some((param) => {
          return param === option[this.optionDisplayProperty!];
        });
      });
    } else {
      return this.options.filter((option) => paramsList.some((param) => param === option));
    }
  }
}
